<template>
  <div>
    <div class="page-wrapper" :class="layoutobj">
      <div class="page-header" :class="{ close_icon:!togglesidebar }">
        <Header @clicked="sidebar_toggle" />
      </div>
      <div class="page-body-wrapper">
        <div class="bg-overlay" :class="{active: activeoverlay }" @click="removeoverlay()"></div>
        <div class="sidebar-wrapper" :class="[{ close_icon : !togglesidebar }]" :sidebar-layout="layout.settings.sidebar_setting">
          <Sidebar @clicked="sidebar_toggle" />
        </div>
         <!--Start Show Session Expire Warning Popup here -->
            <div class="modal fade" id="session-expire-warning-modal" tabindex="-1" role="dialog" aria-labelledby="selectBeneficiaryCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-primary">
                            <h5 class="modal-title" id="selectBeneficiaryCenterTitle">Session Expire Warning</h5>
                            <button class="close text-white" type="button" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body ">
                          Your session will expire in <span id="seconds-timer">{{time}}</span> seconds. Do you want to extend the session?
                        </div>
                        <div class="modal-footer">

                            <button id="btnOk" type="button" data-dismiss="modal" @click="refreshUserToken" class="btn btn-primary">Yes</button>

                            <button id="btnSessionExpiredCancelled" type="button" class="btn btn-outline-danger" data-dismiss="modal">Cancel</button>

                            <button id="btnLogoutNow" @click="logoutUser" type="button" class="btn btn-outline-danger">Logout now</button>

                        </div>
                    </div>
                </div>
            </div>
            <!--End Show Session Expire Warning Popup here -->
        <div class="page-body" @click="hidesecondmenu()">
          <transition name="fadeIn" enter-active-class="animated fadeIn">
           <router-view class="view"></router-view>
          </transition>
        </div>
        <Footer/>
      </div>
      <TapTop/>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { layoutClasses } from '../constants/layout';
  import Header from './header';
  import Sidebar from './sidebar';
  import Footer from './footer';
  import TapTop from './taptop';
  import $ from 'jquery';
  export default {
    name: 'mainpage',
    // props:['sidebar_toggle_var'],
    components:{
      Header,
      Sidebar,
      Footer,
      TapTop
    },
    data(){
      return{
        mobileheader_toggle_var: false,
        sidebar_toggle_var: false,
        horizontal_Sidebar: true,
        resized:false,
        layoutobj:{},
        isSecurityQuestion: JSON.parse(localStorage.getItem('isSecurityQuestion')),
        changePassword: JSON.parse(localStorage.getItem('forceChangeOfPassword')),
        changePin: JSON.parse(localStorage.getItem('forceChangePin')),
        isEmail: localStorage.getItem('email'),
        time: 60,
        timerID: null,
      };
    },
    computed: {
      ...mapState({
        menuItems: state => state.menu.data,
        layout: state => state.layout.layout,
        togglesidebar: (state) => state.menu.togglesidebar,
        activeoverlay: (state) => state.menu.activeoverlay,
        // get token from store
        token: state => state.authentication.accessToken,
        details: state => state.dashboard.dashboardData,
        // eslint-disable-next-line no-confusing-arrow
        profilePicture: state => state.dashboard ? state.dashboard.profilePicture : null,
        userName() {
          return this.details ? this.details.customerDetails.userName : null;
        },
        imageBase64() {
          return this.profilePicture ? `data:image/png;base64,${this.profilePicture}` : null;
        },
        isIdle() {
          return this.$store.state.idleVue.isIdle;
        },
      }),
      userEmail() {
        return this.details ? this.details.customerDetails.email : '';
      },
      layoutobject: {
        get: function () {
          return JSON.parse(JSON.stringify(layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout)))[this.layout.settings.layout];
        },
        set: function () {
          this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
          this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layout.settings.layout];
          return this.layoutobj;
        }
      }
    },
    watch:{
      isIdle: function(){
        if(this.isIdle){
          $('#session-expire-warning-modal').modal('show');
          this.countdown();
        } else {
          this.clearTimerId();
          $('#session-expire-warning-modal').modal('hide');
        }
      },
      '$route' (){
        this.menuItems.filter(items => {
          if (items.path === this.$route.path)
            this.$store.dispatch('menu/setActiveRoute', items);
          if (!items.children) return false;
          items.children.filter(subItems => {
            if (subItems.path === this.$route.path)
              this.$store.dispatch('menu/setActiveRoute', subItems);
            if (!subItems.children) return false;
            subItems.children.filter(subSubItems => {
              if (subSubItems.path === this.$route.path)
                this.$store.dispatch('menu/setActiveRoute', subSubItems);
            });
          });
        });
        this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
        if((window.innerWidth < 991 && this.layout.settings.layout === 'LosAngeles') || (window.innerWidth < 991 && this.layout.settings.layout === 'Singapore') || (window.innerWidth < 991 && this.layout.settings.layout === 'Barcelona')) {
          const newlayout = JSON.parse(JSON.stringify(this.layoutobj).replace('horizontal-wrapper', 'compact-wrapper'));
          this.layoutobj = JSON.parse(JSON.stringify(newlayout))[this.layout.settings.layout];
        } else  {
          this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layout.settings.layout]; 
        }
      },
      sidebar_toggle_var: function (){
        this.resized = (this.width <= 991) ? !this.sidebar_toggle_var : this.sidebar_toggle_var;      
      }
    },
    async mounted(){
      
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      this.resized = this.sidebar_toggle_var;
      this.$store.dispatch('layout/set');
      // this.$router.replace({ 'query': null }).catch(err => err);
      this.layout.settings.layout = this.$route.query.layout? this.$route.query.layout : 'Dubai';
      this.layoutobj = layoutClasses.find((item) => Object.keys(item).pop() === this.layout.settings.layout);
      this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[this.layout.settings.layout]; 

      // this.$store.dispatch('dashboard/getProfilePicture', { username: this.userName });
      if(this.isSecurityQuestion) {
        this.$router.push('/settings/reset-security-question');
      }
      if(this.changePin && !this.isSecurityQuestion) {
        this.$router.push('/settings/change-pin');
      }
      if(this.changePassword) {
        this.$router.push('/settings/change-password');
      }
      try {
        await this.$store.dispatch('dashboard/getDashboardData');
        if(this.userEmail === '' && !this.changePin && !this.isSecurityQuestion) {
          this.$swal({
            text:`Kindly note that your limit was crashed due to no Email on your account. Kindly proceed to update your Email.`,
            showCancelButton: true,
            confirmButtonText: 'Proceed',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn btn-primary',
            confirmButtonClass: 'btn btn-success mr-2',
            buttonsStyling: false,
            type:'info'
          }).then((result) => {
            if(result.value) {
              this.$router.push({ name: 'account-update' });
            }
          });
        }
        await this.$store.dispatch('dashboard/getProfilePicture', { username: this.userName });
      } catch(error) {
        if (error.response.status === 401) {
          this.$swal({
            title: 'Oops...',
            text: 'Your session has expired, please login again',
            type: 'error',
            confirmButtonText: 'OK'
          }).then(() => {
            this.logoutUser();
          });
        }
        if (error.response.status === 500 || error.response.status === 400) {
          this.$swal({
            title: 'Oops...',
            text: 'Something went wrong, please try again',
            type: 'error',
            confirmButtonText: 'OK'
          }).then(() => {
            this.logoutUser();
          });
        }
      }
      // call refresh token action every 15 minutes
      setInterval(() => {
        this.$store.dispatch('refreshToken');
      }, 900000);
    },
    methods:{
      refreshUserToken () {
        this.$store.dispatch('refreshToken');
      },
      countdown() {
        this.time = 60;
        this.timerID = setInterval(() => {
          if(this.time > 0) this.time--;
          if(this.time < 1) {
            this.logoutUser();
            window.location.reload();
          }
        }, 1000);
      },
      clearTimerId() {
        clearInterval(this.timerID);
      },
      logoutUser() {
        this.$store.dispatch('logout');
        $('#session-expire-warning-modal').modal('hide');
      },
      sidebar_toggle(value) {
        this.sidebar_toggle_var = !value;
      },
      mobiletoggle_toggle(value) {
        this.mobileheader_toggle_var = value;
      },
      handleResize() {
        this.$store.dispatch('menu/resizetoggle');
      },
      removeoverlay() {
        this.$store.state.menu.activeoverlay = false;
        if(window.innerWidth < 991){  
          this.$store.state.menu.togglesidebar = false; 
        }
        this.menuItems.filter(menuItem => {
          menuItem.active = false;
        });
      }, 
      hidesecondmenu() {
        if(this.layoutobject.split(' ').includes('compact-sidebar')) {
          this.menuItems.filter(menuItem => {
            menuItem.active = false;
          });
        }
        if(window.innerWidth < 991) {
          this.$store.state.menu.togglesidebar = false; 
        }
      }
    }
  };
</script>

